import React, { useState } from "react";
import { Link } from "react-router-dom";
import defaultuserprofile from "../../assets/defaultuserprofile.webp";
import LanguageSwitcher from "../language/LanguageSwitcher";

const Navbar = ({ currentUser }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex justify-between p-2 px-2 relative h-16 bg-white">
      <div>
        <Link to="/dashboard">
          <img
            src="../../logo.svg"
            alt="logo"
            width={100}
            height={100}
            className="ml-4 mt-1"
          />
        </Link>
      </div>
      <div className="flex items-center ml-auto">
        {/* {searchComponent} */}
        <div
          className="flex items-center gap-2 cursor-pointer p-1 rounded-lg mr-4"
          onClick={() => setIsOpen(!isOpen)}
          id="profile"
        >
          <LanguageSwitcher />
          {currentUser?.photoURL ? (
            <img
              src={currentUser.photoURL}
              className="rounded-full w-9 h-9"
              height={20}
              width={20}
              alt="avatar"
            />
          ) : (
            <img
              src={defaultuserprofile}
              className="rounded-full w-9 h-9"
              height={20}
              width={20}
              alt="avatar"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
